import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import moment from 'moment';

import OverflowTooltip from '../../UI/OverflowTooltip/OverflowTooltip';
import { EstadoEiffelChip, EstadoFacturaChip } from '../EstadoSmartScan/EstadoSmartScan';
import { formatImporte } from '../datosSmartScan';
import colores from '../../Impresion/Bandeja/coloresBandeja';

const useStyles = makeStyles((theme) => ({
  lista: {
    backgroundColor: 'white',
    border: `1px solid ${colores.borde}`,
    borderRadius: '6px',
    boxShadow: colores.sombra,
    overflowY: 'auto',
    minHeight: 0
  },
  item: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    gap: '2px 12px',
    padding: '12px 16px',
    borderBottom: `1px solid ${colores.linea}`,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#fafafa'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px'
    }
  },
  seleccionado: {
    backgroundColor: `${colores.primarioClaro} !important`,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: '4px',
      background: colores.gradiente
    }
  },
  nueva: {
    animation: '$aparecer 1.2s ease-out'
  },
  '@keyframes aparecer': {
    from: { backgroundColor: '#fff3e0' },
    to: { backgroundColor: 'transparent' }
  },
  proveedor: {
    fontWeight: 500
  },
  sub: {
    fontSize: '12px',
    color: colores.tenue
  },
  total: {
    textAlign: 'right',
    fontWeight: 500,
    fontSize: '13px',
    whiteSpace: 'nowrap'
  },
  estado: {
    textAlign: 'right'
  },
  vacio: {
    padding: '40px',
    textAlign: 'center',
    color: colores.tenue
  }
}));

/** Lista de facturas de la bandeja: proveedor, número, total y estado (de revisión o de Eiffel si está aprobada). */
const ListaFacturas = ({ facturas, seleccionado, onSeleccionar, mensajeVacio, idNueva }) => {
  const classes = useStyles();

  if (facturas.length === 0) {
    return (
      <div className={`${classes.lista} ${classes.vacio}`}>
        <InboxOutlinedIcon style={{ fontSize: 40 }} />
        <Typography variant="body2">{mensajeVacio}</Typography>
      </div>
    );
  }

  return (
    <div className={classes.lista}>
      {facturas.map((factura) => (
        <div
          key={factura.id}
          className={`${classes.item} ${factura.id === seleccionado ? classes.seleccionado : ''} ${factura.id === idNueva ? classes.nueva : ''}`}
          onClick={() => onSeleccionar(factura)}
        >
          <OverflowTooltip className={classes.proveedor}>{factura.proveedor || factura.cuit}</OverflowTooltip>
          <div className={classes.total}>{formatImporte(factura.total)}</div>
          <OverflowTooltip className={classes.sub}>
            {`FC ${factura.letra} ${factura.numero} · recibida ${moment(factura.recibida).format('DD/MM HH:mm')}`}
          </OverflowTooltip>
          <div className={classes.estado}>
            {factura.estado === 'aprobada' ? (
              <EstadoEiffelChip eiffel={factura.eiffel} style={{ height: '20px' }} />
            ) : (
              <EstadoFacturaChip factura={factura} style={{ height: '20px' }} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListaFacturas;
